module.exports = {
micro_url: 'https://calendarbuilder-ms.activityconnection.com',
  ORIENTATION_PORTRAIT: 'Portrait',
  ORIENTATION_LANDSCAPE: 'Landscape',
  FORMAT_A0: 'A0',
  FORMAT_A1: 'A1',
  FORMAT_A2: 'A2',
  FORMAT_A3: 'A3',
  FORMAT_A4: 'A4',
  FORMAT_A5: 'A5',
  FORMAT_A6: 'A6',
  FORMAT_A7: 'A7',
  FORMAT_A8: 'A8',
  FORMAT_A9: 'A9',
  FORMAT_B0: 'B0',
  FORMAT_B1: 'B1',
  FORMAT_B2: 'B2',
  FORMAT_B3: 'B3',
  FORMAT_B4: 'B4',
  FORMAT_B5: 'B5',
  FORMAT_B6: 'B6',
  FORMAT_B7: 'B7',
  FORMAT_B8: 'B8',
  FORMAT_B9: 'B9',
  FORMAT_B10: 'B10',
  FORMAT_C5E: 'C5E',
  FORMAT_COMM10E: 'Comm10E',
  FORMAT_DLE: 'DLE',
  FORMAT_EXECUTIVE: 'Executive',
  FORMAT_FOLIO: 'Folio',
  FORMAT_LEDGER: 'Ledger',
  FORMAT_LEGAL: 'Legal',
  FORMAT_LETTER: 'Letter',
  FORMAT_TABLOID: 'Tabloid',
  DISMISSIBLE: 'DISMISSIBLE',
  PESTER: 'PESTER',
  STICKY: 'STICKY',
  ONCE_PER_USER: 'ONCE_PER_USER',
  EVERYTIME: 'EVERYTIME',
  DISPLAY_DURATION_DEFAULT: 5,
  BACKGROUND_COLOR_DEFAULT: '#1A5CC7',
  TEXT_COLOR_DEFAULT: '#FFFFFF',
SESSION_TIMEOUT: 60,
  FILE_SIZE_UPLOAD_LIMIT: 10, // 10M
  OFFLINE_SAVE_INTERVAL: 3000, // 3s
  THUMBNAIL_GENERATION_INTERVAL: 3000, // 3s
};



// WEBPACK FOOTER //
// ./src/data/constant.js